<template>
  <button @click="handleClick">
    <slot></slot>
  </button>
</template>

<script>
export default {
  methods: {
    handleClick(...args) {
      this.$emit('click', ...args);
    },
  },
};
</script>

<style lang="scss" scoped>
button {
  background-color: #4682b4;
  border: 1px solid #38678f;
  color: white;
  cursor: pointer;
  font-size: 1.6em;
  font-weight: bold;
  letter-spacing: .03em;
  margin: 0;
  padding: .4em .8em;
  transition: background-color 200ms;
  vertical-align: middle;

  &:hover {
    background-color: #38678f;
  }
}
</style>



/** WEBPACK FOOTER **
 ** Button.vue?d929b3d0
 **/